module.exports = __webpack_public_path__ + "static/media/dana3.ede98f0c.jpg";